/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexDto } from '../../models/backend-capex-dto';
import { BackendCapexRequestDto } from '../../models/backend-capex-request-dto';

export interface EconomicIndicatorsCapexsCreate$FormData$Params {
  body?: BackendCapexRequestDto;
}

export function economicIndicatorsCapexsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params?: EconomicIndicatorsCapexsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexDto>;
    }),
  );
}

economicIndicatorsCapexsCreate$FormData.PATH = '/api/economic_indicators/capexs/';
